import React from "react";
import { useSelector } from "react-redux";
import { userProfile } from "../../assets";
import { getUser } from "../../redux/slice/userSlice";

const AdminProfile = () => {
  const user = useSelector(getUser);
  return (
    <section className="bg-primary flex flex-col gap-10 w-full sm:p-7 p-3 rounded-[4px] border border-adminMainBorder justify-center items-center">
      <div className="">
        <img
          src={userProfile}
          alt=""
          className="rounded-[50%] h-[150px] w-[150px] object-cover"
        />
      </div>
      <article className="flex flex-col gap-2">
        <h3 className="self-center font-semibold text-[24px] ">{user?.name}</h3>
        <div className="sm:self-start self-center flex gap-2 items-center">
          <span className="font-medium text-[18px] text-textSecondary sm:block hidden">
            Email:
          </span>
          <span className="font-medium text-[18px]">{user?.email}</span>
        </div>
        <div className="sm:self-start self-center flex gap-2 items-center flex-wrap">
          <span className="font-medium text-[18px] text-textSecondary sm:block hidden">
            Mobile Number:
          </span>
          <span className="font-medium text-[18px]">{user?.mobileNumber}</span>
        </div>
      </article>
    </section>
  );
};

export default AdminProfile;
